export default __webpack_public_path__ + "static/media/headerLogo.297c312a.png";